import { Packaging } from "src/api/client-api/packagings/useGetOnePackaging";
import { PackagingFormType } from "./PackagingForm/PackagingForm.types";
import { PackagingWrite } from "src/api/client-api/packagings/useCreatePackaging";
import { formatStringForBackend } from "src/utils/formatting";

export class PackagingService {
    static getPackagingToCreate = (existingPackaging?: Packaging): PackagingFormType => {
        if (existingPackaging === undefined) {
            const newPackaging: PackagingFormType = {
                name: null,
                externalId: null,
            };
            return newPackaging;
        }

        const formattedPackaging: PackagingFormType = {
            id: existingPackaging.id,
            name: existingPackaging.name,
            externalId: existingPackaging.externalId ?? null,
        };
        return formattedPackaging;
    };

    static packagingFormToPackagingWrite = (
        packagingForm: PackagingFormType,
        ownedBy: IRI | null = null,
    ): PackagingWrite => {
        const packagingToCreate: PackagingWrite = {
            id: packagingForm.id,

            name: formatStringForBackend(packagingForm.name),
            externalId: formatStringForBackend(packagingForm.externalId),
        };

        if (ownedBy !== null) {
            packagingToCreate.ownedBy = ownedBy;
        }

        return packagingToCreate;
    };
}
